var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class ArchivePressReview extends Component {
    constructor() {
        super('ArchivePressReview', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.press-review').on('mouseenter', (event, pressReview) => {
                event.preventDefault();
                $('.scrollable-column-lg .btn-toggle-content').removeClass('is-active');
                $('.scrollable-column-lg').addClass('is-opened');
                $('.press-review-details').addClass('d-none');
                $(pressReview.attr('href')).removeClass('d-none');
            });
            $('.scrollable-column-lg .btn-toggle-content').on('click', (event) => {
                event.preventDefault();
                $('.scrollable-column-lg').removeClass('is-opened');
            });
            this.success();
        });
    }
}
